import byIdMaker from 'reducersMakers/byIdMaker';
import * as actions from 'actions';

export default byIdMaker({
  fetchSuccessTypes: [
    actions.GOALS_FETCH_SUCCESS,
    actions.GOALS_RECEIVED
  ],
  entityType: 'goals',
  updateSuccessTypes: [ actions.GOAL_UPDATE ],
  updateKey: 'goalId'
});



/** WEBPACK FOOTER **
 ** ./src/members/state/goals/byId/reducer.js
 **/